//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('copyButton', [
    '$document',
    '$timeout',
    'ClipboardService',
    function(
            $document,
            $timeout,
            ClipboardService,
        ) {
      return {
        restrict: 'A',
        scope: { },
        link(scope, element) {
          let removeTooltipPromise;
          const COPIED_TEXT = 'Copied!';

          scope.element = element;

          const showTooltip = function() {
            scope.element.tooltip('show');

            $timeout.cancel(removeTooltipPromise);
            removeTooltipPromise = $timeout(() => {
              scope.element.tooltip('hide');
            }, 2000);
          };

                    // Source for browser support: http://caniuse.com/#feat=clipboard
          scope.element.on('click', () => {
            const copyText = scope.element.attr('data-clipboard-text');
            const copySuccessful = ClipboardService.copyString(scope.element, copyText);

            if (copySuccessful) {
              scope.$applyAsync(() => {
                scope.$emit('copy-button:copied');
              });

                            // Show tooltip if attribute is set
              if (scope.element.attr('copy-show-tooltip')) {
                if (!scope.element.attr('tooltip') && !scope.element.attr('title')) {
                  scope.element.attr('title', COPIED_TEXT);
                  scope.element.tooltip({ trigger: 'manual' });
                  showTooltip();
                } else if (scope.element.attr('title') === COPIED_TEXT) {
                  showTooltip();
                }
              }
            }
          });
        },
      };
    },
  ]);
})();
